import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { CountriesTab } from '../../components/RegulatoryWatchAdmin/CountriesTab';

export const AdminCountriesPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <CountriesTab />
    </FlexCol>
  );
};
